const openUrls = [
  '/bulktrackconsignment',
  '/rivigoClientPincodeServiceability',
  '/login',
  '/epod'
];

export default openUrls;
